import React, { useState } from 'react';
import { Box, Button, Center, Flex, Grid, GridItem, Input, Text, Textarea, VStack } from '@chakra-ui/react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Field } from '@/components/ui/field';
import { Controller, useForm } from 'react-hook-form';
import { NativeSelectField, NativeSelectRoot } from './ui/native-select';

const industryOptions = [
  'Accountancy',
  'Advertising',
  'Agriculture',
  'Apparel',
  'Construction',
  'art gallery',
  'Association',
  'Consulting',
  'Auto Parts Manufacturing',
  'Engineering',
  'Finance',
  'Banking',
  'Legal',
  'Manufacturing',
  'beauty',
  'Biotechnology',
  'Retail',
  'Car Rental Agent',
  'Pharmaceuticals',
  'Car Rental Broker',
  'Technology',
  'Chemicals',
  'Telecommunications',
  'Communications',
  'Other',
  'Destination Management',
  'Distance Seller',
  'Education',
  'Electronics',
  'Energy',
  'Entertainment',
  'Environmental',
  'Events',
  'Expense Management',
  'Finance - Trading',
  'Financial & Payment',
  'Food & Beverage',
  'Government',
  'Healthcare',
  'Hospitality',
  'Hotel Broker',
  'Industrial Installation',
  'Insurance',
  'Logistics',
  'Machinery',
  'Manufacturing - Electronics',
  'Manufacturing - Jewellery',
  'Manufacturing - Machinery and Equipment',
  'Media',
  'Mining',
  'Motor Industry',
  'Not For Profit',
  'PCE',
  'Petrochemical',
  'Recreation',
  'Relocation',
  'Service Provider',
  'Shipping',
  'Sports Body',
  'Tobacco',
  'Tour Operator',
  'Training',

  'Transportation',
  'Travel Agent',
  'Utilities'
];

const countryOptions = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua & Deps',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Central African Rep',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo {Democratic Rep}',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland {Republic}',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea North',
  'Korea South',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar, {Burma}',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'St Kitts & Nevis',
  'St Lucia',
  'Saint Vincent & the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome & Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Togo',
  'Tonga',
  'Trinidad & Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

/*const countryCollection = createListCollection({
  items: countryOptions.map((country) => ({
    key: country,
    value: country
  }))
});*/

const jobTitleOptions = [
  'Accountant',
  'Accounts Payable Accountant',
  'Accounts Payable Clerk',
  'Business Owner',
  'Chief Executive Officer (CEO)',
  'Chief Financial Officer (CFO)',
  'Chief Operations Officer (COO)',
  'Concur Manager',
  'Event Planner',
  'Financial Controller',
  'Financial Manager',
  'Head Buyer',
  'Indirect Tax Manager/Director',
  'Indirect VAT Manager/Director',
  'Logistics Manager',
  'Other',
  'Procurement Director',
  'Sales Director',
  'Tax Director',
  'Tax Manager',
  'VAT Manager',
  'Vice President',
  'Head of Accounting',
  'Head of Finance and Treasury',
  'Head of Tax',
  'Supply Chain Manager',
  'Travel Manager'
];

const ContactForm = () => {
  const { t } = useTranslation('landing');
  const [submitted, setSubmitted] = useState(false);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      contactNumber: '',
      company: '',
      country: '',
      jobTitle: '',
      industry: '',
      message: ''
    }
  });

  const onSubmit = async (values) => {
    try {
      const key = process.env.NEXT_PUBLIC_CONTACT_US_APIKEY;
      const url = process.env.NEXT_PUBLIC_CONTACT_US_URL;
      await axios({
        method: 'POST',
        url,
        headers: {
          'x-api-key': key,
          'Content-Type': 'application/json; charset=utf-8'
        },
        data: {
          ...values,
          date: new Date().toISOString()
        }
      });
      // console.info('Form data submitted:', response?.data);
      setSubmitted(true);
    } catch (error) {
      setSubmitted(true);
      console.error('Error submitting form data:', error);
    }
  };

  return (
    <Box py={{ base: '8', md: '12', lg: '24' }}>
      <div>
        {!submitted && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid templateColumns='repeat(4, 1fr)' gap={6} my={6}>
              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.firstName')} required>
                  <Controller
                    name='firstName'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        required
                        placeholder={t('contactForm.firstNamePlaceholder')}
                        bgColor='bg-input'
                      />
                    )}
                  />
                </Field>
              </GridItem>

              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.lastName')} required>
                  <Controller
                    name='lastName'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        required
                        placeholder={t('contactForm.lastNamePlaceholder')}
                        bgColor='bg-input'
                      />
                    )}
                  />
                </Field>
              </GridItem>

              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.email')} required>
                  <Controller
                    name='email'
                    control={control}
                    rules={{ required: true, pattern: /^\S+@\S+$/i }}
                    render={({ field }) => (
                      <Input {...field} type='email' required placeholder={t('contactForm.emailPlaceholder')} />
                    )}
                  />
                </Field>
              </GridItem>

              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.contactNumber')} required>
                  <Controller
                    name='contactNumber'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input {...field} required placeholder={t('contactForm.contactNumberPlaceholder')} />
                    )}
                  />
                </Field>
              </GridItem>

              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.company')} required>
                  <Controller
                    name='company'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        required
                        color='linear(to-l, #7928CA, #FF0080)'
                        placeholder={t('contactForm.companyPlaceholder')}
                      />
                    )}
                  />
                </Field>
              </GridItem>
              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.country')} required>
                  <Controller
                    name='country'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <NativeSelectRoot {...field} colorPalette='brand'>
                        <NativeSelectField placeholder={t('contactForm.countryPlaceholder')}>
                          {countryOptions.map((country) => (
                            <option key={country} value={country}>
                              {country}
                            </option>
                          ))}
                        </NativeSelectField>
                      </NativeSelectRoot>
                    )}
                  />
                </Field>
              </GridItem>

              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.jobTitle')} required>
                  <Controller
                    name='jobTitle'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <NativeSelectRoot {...field} colorPalette='brand'>
                        <NativeSelectField placeholder={t('contactForm.jobTitlePlaceholder')}>
                          {jobTitleOptions.map((title) => (
                            <option key={title} value={title}>
                              {title}
                            </option>
                          ))}
                        </NativeSelectField>
                      </NativeSelectRoot>
                    )}
                  />
                </Field>
              </GridItem>
              <GridItem colSpan={{ base: 4, md: 2, lg: 2 }}>
                <Field label={t('contactForm.industry')} required>
                  <Controller
                    name='industry'
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <NativeSelectRoot {...field} colorPalette='brand'>
                        <NativeSelectField placeholder={t('contactForm.industryPlaceholder')}>
                          {industryOptions.map((industry) => (
                            <option key={industry} value={industry}>
                              {industry}
                            </option>
                          ))}
                        </NativeSelectField>
                      </NativeSelectRoot>
                    )}
                  />
                </Field>
              </GridItem>
            </Grid>

            <Field label={t('contactForm.message')} required>
              <Controller
                name='message'
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Textarea {...field} bgColor='bg-input' variant='subtle' size='lg' colorPalette='brand' />
                )}
              />
            </Field>

            <Flex justifyContent='flex-end'>
              <Button mt={4} colorPalette='brand' type='submit'>
                {t('contactForm.submit')}
              </Button>
            </Flex>
          </form>
        )}
        {submitted && (
          <Center>
            <VStack>
              <Text mt='5' fontSize='xl'>
                {t('contactForm.thankYou')}
              </Text>
              <Text mt='5' fontSize='xl'>
                {t('contactForm.getBack')}
              </Text>
            </VStack>
          </Center>
        )}
      </div>
    </Box>
  );
};

export default ContactForm;
